import { Component, OnInit } from '@angular/core';
import { Projects, IProject } from '../../../_data/projects';
import { NgxCarousel } from 'ngx-carousel';
@Component({
  selector: 'app-portfolio-preview',
  templateUrl: './portfolio-preview.component.html',
  styleUrls: ['./portfolio-preview.component.scss'],
})
export class PortfolioPreviewComponent {
  projects: IProject[] = [...Projects];

  public carouselPortfolio: NgxCarousel;

  constructor() {
    this.carouselPortfolio = {
      grid: { xs: 2, sm: 2, md: 3, lg: 4, all: 0 },
      slide: 1,
      speed: 400,
      interval: 10000,
      animation: 'lazy',
      point: {
        visible: false,
      },
      load: 2,
      touch: true,
      easing: 'ease-in-out',
      loop: true,
      custom: 'banner',
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/portfolio/preview/portfolio-preview.component.ts